import React from "react";
import "../../styles/hero.css";
import hero from "../../assets/hero.png";
import { useNavigate } from "react-router-dom";


const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="pro-hero-wrapper container">
      <div className="pro-hero-card row align-items-center g-0">
        {/* LEFT TEXT SECTION */}
        <div className="col-lg-7 col-md-12 pro-hero-text-col position-relative">
          <h1 className="pro-hero-title">
            Your Degree, Your Future –<br />
            The Smart Way to Learn
          </h1>

          <p className="pro-hero-subtitle">
            UGC-recognised online degree programs + Professional course
            integration for career success.
          </p>

          <div className="pro-hero-btn-wrapper">
              
            <button className="pro-btn-enroll" onClick={() => navigate("/contact")}>
              Start Your Global Journey Today
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="col-lg-5 col-md-12 pro-hero-img-col">
          {/* 1. Background Pattern (z-index: 0) */}
       {/*    <img
            src="https://school.madhiacademy.com/wp-content/uploads/sites/2/2025/09/Asset-05-copy.png"
            alt="Pattern"
            className="pro-hero-pattern"
          /> */}

          {/* 2. Main Professional Image (z-index: 2) */}
          <img
            src={hero}
            alt="Global Professional"
            className="pro-hero-main-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
